import type {SuggestLocation} from './suggest-location'

export const enum SuggestObjectAction {
  SUBSTITUTE = 'substitute',
  SEARCH = 'search',
}

type SuggestDistance = {
  text: string
  value: number
}

type SuggestTitle = {
  hl?: number[][]
  text: string
}

type SuggestFavorite = {
  alias: string
  name?: string
}

const enum AddressType {
  ADDRESS = 'address',
  ORGANIZATION = 'organization',
}

export type SuggestObject = {
  action?: SuggestObjectAction
  canBeAutoSelected: boolean
  distance?: SuggestDistance
  location?: SuggestLocation
  log: string
  id?: string
  city?: string
  uri?: string
  position: SuggestLocation
  personal?: {
    favorite?: SuggestFavorite
    isHistoryItem?: boolean
  }
  placeId: string
  subtitle: SuggestTitle
  text: string
  title: SuggestTitle
  type?: AddressType
  address?: {
    addressId?: string
  }
  isSavedAddress?: boolean
  house?: string
  country?: string
  street?: string
  porchnumber?: string
  entrance?: string
  method?: string
  floorNumber?: string
  quartersNumber?: string
  doorPhoneNumber?: string
  comment?: string
  comment_courier?: string
  contact?: {
    email?: string
    phoneNumber?: string
  }
  districts?: string[]
  area?: string[]
}
